module.exports = __webpack_public_path__ + "static/media/freshwater.d9b4b628.svg";